"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.visitObject = exports.flatDeep = exports.visitPropsExpression = exports.isJSExpression = exports.isBasicType = void 0;
/** is simple basic type */
var isBasicType = function (value) { return ['string', 'boolean', 'number', 'undefined'].includes(typeof value) || value === null; };
exports.isBasicType = isBasicType;
/** check if data is JSExpression. there will be type: i18n/function and other extensions */
var isJSExpression = function (value) { return (value === null || value === void 0 ? void 0 : value.type) === 'JSExpression' && typeof (value === null || value === void 0 ? void 0 : value.value) === 'string'; };
exports.isJSExpression = isJSExpression;
/** visit JSExpression and return the modified */
var visitPropsExpression = function (props, onFound) {
    if ((0, exports.isBasicType)(props))
        return props;
    if (Array.isArray(props)) {
        return props.map(function (prop) { return (0, exports.visitPropsExpression)(prop, onFound); });
    }
    var obj = props;
    return Object.keys(obj).reduce(function (prev, cur) {
        var _a, _b;
        var value = obj[cur];
        if ((0, exports.isJSExpression)(value)) {
            return __assign(__assign({}, prev), (_a = {}, _a[cur] = onFound(value.value, obj, cur, value), _a));
        }
        return __assign(__assign({}, prev), (_b = {}, _b[cur] = (0, exports.visitPropsExpression)(obj[cur], onFound), _b));
    }, {});
};
exports.visitPropsExpression = visitPropsExpression;
var flatDeep = function (obj, shouldSkip, keys) {
    var _a;
    if (keys === void 0) { keys = []; }
    if ((0, exports.isBasicType)(obj) || (shouldSkip === null || shouldSkip === void 0 ? void 0 : shouldSkip(obj)))
        return _a = {}, _a[keys.join('.')] = obj, _a;
    var result = {};
    if (Array.isArray(obj)) {
        obj.forEach(function (child, index) {
            Object.assign(result, (0, exports.flatDeep)(child, shouldSkip, __spreadArray(__spreadArray([], __read(keys), false), [String(index)], false)));
        });
        return result;
    }
    Object.keys(obj).forEach(function (key) {
        Object.assign(result, (0, exports.flatDeep)(obj[key], shouldSkip, __spreadArray(__spreadArray([], __read(keys), false), [key], false)));
    });
    return result;
};
exports.flatDeep = flatDeep;
var visitObject = function (obj, onFound, keys) {
    if (keys === void 0) { keys = []; }
    if ((0, exports.isBasicType)(obj)) {
        onFound(obj, keys.join('.'));
        return;
    }
    if (Array.isArray(obj)) {
        obj.forEach(function (child, index) {
            var nextKeys = __spreadArray(__spreadArray([], __read(keys), false), [String(index)], false);
            var shouldContinue = onFound(child, nextKeys.join('.'));
            if (shouldContinue) {
                (0, exports.visitObject)(child, onFound, nextKeys);
            }
        });
        return;
    }
    Object.keys(obj).forEach(function (key) {
        var nextKeys = __spreadArray(__spreadArray([], __read(keys), false), [key], false);
        var shouldContinue = onFound(obj[key], nextKeys.join('.'));
        if (shouldContinue) {
            (0, exports.visitObject)(obj[key], onFound, nextKeys);
        }
    });
};
exports.visitObject = visitObject;
exports.default = exports.visitPropsExpression;
